<div class="flex h-full w-full flex-col overflow-hidden">
  <div
    class="z-3 text-md flex h-[41px] flex-shrink-0 items-center justify-between border-b border-neutral-200 px-4 font-semibold"
    [class]="backgroundColor"
  >
    <dojo-icon-button [icon]="'arrow-left'" [size]="'xs'" [iconClass]="'text-secondary'" (click)="goToListView()" />
    <div class="flex-1">
      <ng-content select="[title]" />
    </div>
  </div>

  <div class="flex flex-1 overflow-hidden">
    <as-split [direction]="'horizontal'" unit="pixel" class="h-full" [gutterSize]="1" [useTransition]="true">
      <as-split-area [size]="280" [minSize]="180">
        <div class="relative flex h-full flex-col gap-4 overflow-y-auto p-4">
          <ng-content select="[sidebar]" />
        </div>
      </as-split-area>

      <as-split-area [size]="'*'" [minSize]="300" class="flex h-full flex-col !overflow-y-hidden">
        <ng-content />
      </as-split-area>
    </as-split>
  </div>
</div>
